import React from 'react'
import IconButton from 'material-ui/IconButton'
import Chip from 'material-ui/Chip'
import Avatar from 'material-ui/Avatar';
import { Link } from 'react-router-dom'
import { stringify } from 'query-string'
import ContentCreate from 'material-ui/svg-icons/content/create';
import AlertWarning from 'material-ui/svg-icons/alert/warning';

const hasDocDef = ({ id, fields }) => {
	if ( ['new', 'transmitted', 'di_collected'].indexOf(fields.status) !== -1 ) {
		return null;
	}
	const editButton = (
		<IconButton
			containerElement={<Link to={{
				pathname: `/accounts/${id}`,
				search: stringify({ tab: 2 }),
			}} />}
			style={{ overflow: 'inherit' }}
			>
			<ContentCreate color="#0277bd" />
		</IconButton>
	)
	if ( fields.has_doc_def ) {
		return (
			<div style={{ display: 'flex', alignItems: 'center' }}>
				{editButton}
				<Chip backgroundColor="#ffc107" labelColor="#fff" containerElement={<Link to={{
					pathname: `/accounts/${id}`,
					search: stringify({ tab: 2 }),
				}} />} >
				<Avatar backgroundColor="#ffa000" color="#fff" icon={<AlertWarning />} />
				Doc Def
				</Chip>
			</div>
		)
	}
	return editButton
}

export default hasDocDef



// WEBPACK FOOTER //
// ./src/CollectorAccount/hasDocDef.js